export default "__VITE_ASSET__DItqvkwm__"